import React from 'react';
import PropTypes from 'prop-types';

import SkuBanner from 'features/Sku/shared/SkuBanner';

import { ITEM_SAVE_STATUS } from '../SkuItems.constants';
import messages from './ItemSaveErrorBanner.messages';

const contentFor = failure => {
  if (failure.status === ITEM_SAVE_STATUS.NOTHING_SAVED) {
    // The edit save runs as a sequence, so a mid-sequence failure cannot honestly claim
    // nothing changed; only the create path can.
    return {
      title: messages.totalTitle,
      body: failure.stateUnknown ? messages.totalBodyUncertain : messages.totalBody,
    };
  }
  if (failure.categoriesFailed && failure.modifiersFailed) {
    return { title: messages.bothTitle, body: messages.bothBody };
  }
  if (failure.categoriesFailed) {
    return { title: messages.categoriesTitle, body: messages.categoriesBody };
  }
  return { title: messages.modifiersTitle, body: messages.modifiersBody };
};

const ItemSaveErrorBanner = ({ failure, onDismiss }) => {
  const { title, body } = contentFor(failure);

  return <SkuBanner title={title} body={body} onDismiss={onDismiss} />;
};

ItemSaveErrorBanner.propTypes = {
  failure: PropTypes.shape({
    status: PropTypes.string.isRequired,
    categoriesFailed: PropTypes.bool,
    modifiersFailed: PropTypes.bool,
    stateUnknown: PropTypes.bool,
  }).isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default ItemSaveErrorBanner;
